import { render, staticRenderFns } from "./PaymentChartsTab.vue?vue&type=template&id=6279a8e5"
import script from "./PaymentChartsTab.vue?vue&type=script&lang=js"
export * from "./PaymentChartsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports